// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const Pause: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M8.375 21h-2.25C5.504 21 5 20.526 5 19.941V4.059C5 3.474 5.504 3 6.125 3h2.25C8.996 3 9.5 3.474 9.5 4.059v15.882C9.5 20.526 8.996 21 8.375 21zm9.5 0h-2.25c-.621 0-1.125-.474-1.125-1.059V4.059c0-.585.504-1.059 1.125-1.059h2.25C18.496 3 19 3.474 19 4.059v15.882c0 .585-.504 1.059-1.125 1.059z"
                clipRule="evenodd"
            />
        </svg>
    );
};

export const PauseOffset: IconOffset = {
    vertical: 12,
    horizontal: 20,
};

export default React.memo(Pause);
